import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const PROJECTS = [
  {
    title:
      "Thermal & salinity dispersion modelling — KPGL Thermal Power Plant",
    place: "Bhadreshwar, Kutch, Gujarat",
  },
  {
    title:
      "Thermal & salinity dispersion modelling — NTPL Thermal Power Plant",
    place: "Tuticorin, Tamil Nadu",
  },
  {
    title: "Hydrodynamic modelling & EIA — APSEZ Power Plant",
    place: "Atchuthapuram, Andhra Pradesh",
  },
  {
    title:
      "Hydrodynamic modelling & EIA — CPP Power Plant, River Kundalika & Arabian Sea",
    place: "Maharashtra",
  },
  {
    title: "Dredging survey, planning & advisory — Pearl Qatar beach dredging",
    place: "Doha, Qatar",
  },
];

export default function ProjectsChapter() {
  return (
    <section
      id="projects"
      data-testid="projects-section"
      className="relative px-6 py-32 text-[#F8FAFC] md:px-12 md:py-48"
    >
      <div className="grid grid-cols-1 gap-10 md:grid-cols-12 md:gap-8">
        <div className="md:col-span-12">
          <motion.p
            initial={{ y: 48, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true, margin: "-12% 0px" }}
            transition={{ duration: 0.9, ease: EASE, delay: 0.05 }}
            className="font-mono text-[11px] uppercase tracking-[0.35em] text-[#26c6d3]"
            data-testid="projects-overline"
          >
            Proven at depth · Selected projects
          </motion.p>
          <motion.h2
            initial={{ y: 48, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true, margin: "-12% 0px" }}
            transition={{ duration: 0.9, ease: EASE, delay: 0.12 }}
            className="mt-6 font-display text-4xl font-light leading-[1.02] tracking-tighter md:text-6xl"
          >
            Where we've already dived.
          </motion.h2>

          <ul className="mt-14 md:pr-20">
            {PROJECTS.map((p, i) => (
              <motion.li
                key={i}
                initial={{ y: 32, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true, margin: "-8% 0px" }}
                transition={{ duration: 0.7, ease: EASE, delay: i * 0.05 }}
                className="group flex items-baseline justify-between gap-6 border-t border-white/10 py-6 last:border-b"
                data-testid={`project-row-${i}`}
              >
                <span className="flex items-baseline gap-5">
                  <span className="shrink-0 font-mono text-[10px] tracking-[0.25em] text-[#26c6d3]">
                    P.0{i + 1}
                  </span>
                  <span className="font-display text-lg font-light leading-snug text-[#F8FAFC]/85 transition-colors duration-300 group-hover:text-[#F8FAFC] md:text-2xl">
                    {p.title}
                  </span>
                </span>
                <span className="hidden shrink-0 items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-[#F8FAFC]/40 transition-colors duration-300 group-hover:text-[#f58220] md:flex">
                  {p.place}
                  <ArrowUpRight
                    size={13}
                    strokeWidth={1.5}
                    className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                  />
                </span>
              </motion.li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
